module.exports = __webpack_public_path__ + "assets/img/memory-allocation-comparison.21224ba6.jpg";